import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatDateTime } from 'utils';

export default function DatetimeFormatter({ info }) {
  const { value } = getInfo(info)

  return formatDateTime(value)
}
